module.exports = __webpack_public_path__ + "static/media/how_it_works_rider.05068dbc.jpg";